import React, { useEffect, useState } from 'react';
import {
  DEFAULT_CLOCK_IN_DATA,
  DEFAULT_COMPLETED_FOREST_DATA,
  DEFAULT_EXPENSE_CLAIM_DATA,
  DEFAULT_HARVESTING_CLOSING_DATA,
  DEFAULT_HARVESTING_MAINTENANCE_CHECK_LIST,
  DEFAULT_HOLIDAY_DATA,
  DEFAULT_OTHER_WORK_DATA,
  DEFAULT_STOCK_TAKE_DATA,
  DEFAULT_VEHICAL_CHECK_LIST,
  FORWARDING_DEFAULT_DATA,
  FORWARDING_MAINTENANCE_CHECK_LIST,
  OHER_WORK_CLOSE_DEFAULT_DATA,
} from '../Data/DefaultHFTaskData';
import { useDispatch } from 'react-redux';
import customAxios, { customFormAxios } from 'routes/Pages/util/Api';
import authHeader from 'services/auth/jwt/auth-header';
import { FETCH_ERROR, FETCH_START, FETCH_SUCCESS } from '@jumbo/constants/ActionTypes';
import { useToast } from 'context/tostifyContext';
import { toLocalISO } from 'routes/Pages/GenTask/components/SharedFormFields';

const useHFOpsFormEditHook = (taskData, currentTaskType, open, setOpen, handleSuccessfulSubmit) => {
  const dispatch = useDispatch();
  const [spList, setSPList] = useState([]);
  const [spListObj, setSPListObj] = useState({});

  const { showToast } = useToast();

  //clock in data //vehical check list data`
  const [clockInData, setClockInData] = useState(DEFAULT_CLOCK_IN_DATA);
  const [vehicalCheckList, setVehicalChecklist] = useState(DEFAULT_VEHICAL_CHECK_LIST);

  //harveshing maintencance
  const [harvestingMaintenanceCheckList, setHarvestingMaintenanceCheckList] = useState(
    DEFAULT_HARVESTING_MAINTENANCE_CHECK_LIST,
  );
  const [harvestingClosingData, setHarvestingClosingData] = useState(DEFAULT_HARVESTING_CLOSING_DATA);
  const [productionData, setProductionData] = useState([]);
  const [oldProoductionData, setOldProductionData] = useState({});

  //forwarding data
  const [forwardingData, setForwardingData] = useState(FORWARDING_DEFAULT_DATA);
  const [forwardingMaintenanceCheckListData, setForwardingMaintenanceCheckListData] = useState(
    FORWARDING_MAINTENANCE_CHECK_LIST,
  );

  //daily other work data
  const [dailyOtherWorkCloseData, setDailyOtherWorkCloseData] = useState(OHER_WORK_CLOSE_DEFAULT_DATA);

  //completed foresr
  const [completedForestData, setCompletedForestData] = useState(DEFAULT_COMPLETED_FOREST_DATA);

  //files
  const [files, setFiles] = useState([]);
  const [newUploadedFiles, setNewUploadedFiles] = useState([]);

  //stock takedata
  const [stockTakeData, setStockTakeData] = useState(DEFAULT_STOCK_TAKE_DATA);

  //expensive clain
  const [expenseClaimData, setExpenseClaimData] = useState(DEFAULT_EXPENSE_CLAIM_DATA);

  //other taks
  const [otherTaskData, setOtherTaskData] = useState(DEFAULT_OTHER_WORK_DATA);

  //holiday data
  const [holidayData, setHolidayData] = useState(DEFAULT_HOLIDAY_DATA);

  const [machineList, setMachineList] = useState([]);

  useEffect(() => {
    getSPList();
    getMachineList();
  }, []);
  useEffect(() => {
    if (open && taskData) {
      getTaskInfo();
    }
  }, [taskData, open]);

  useEffect(() => {
    if (!productionData) return;

    const total = productionData.reduce((acc, item) => {
      const val = parseFloat(item?.m3 || '0');
      return acc + (isNaN(val) ? 0 : val);
    }, 0);

    setHarvestingClosingData(prev => ({
      ...prev,
      total_M3: total.toFixed(3),
    }));

    setForwardingData(prev => ({
      ...prev,
      total_M3: total.toFixed(3),
    }));
  }, [productionData]);

  const handleClose = () => {
    setOpen(false);
    setFiles([]);
    setNewUploadedFiles([]);
  };
  const getSPList = async () => {
    try {
      dispatch({ type: FETCH_START });
      customAxios.get('/Ops/GetContracts', { headers: authHeader() }).then(response => {
        let allData = response.data;
        let uniqueData = [];
        let uniqueDataObj = {};
        const whPattern = /WH\d+/i;

        for (let i = 0; i < allData.length; i++) {
          let sp = allData[i];
          if (sp.wH_NumberName) {
            const hasWHNumber = whPattern.test(sp.wH_NumberName);
            const displayName = hasWHNumber ? sp.wH_NumberName : `${sp.contractUniqueID} - ${sp.wH_NumberName}`;

            const spWithDisplayName = { ...sp, displayName };

            uniqueData.push(spWithDisplayName);
            uniqueDataObj[displayName] = spWithDisplayName; // <-- key by displayName now
          }
        }

        setSPList(uniqueData);
        setSPListObj(uniqueDataObj);
        dispatch({ type: FETCH_SUCCESS });
      });
    } catch (error) {
      setSPList([]);
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  const getMachineList = async () => {
    try {
      const response = await customAxios.post('/GenTasks/GetDropdownListArray', ['HarvesterMachine', 'ExtractionMachine'], {
        headers: authHeader(),
      });
      if (response.status === 200) {
        setMachineList(response.data);
      } else {
        setMachineList([]);
        dispatch({ type: FETCH_ERROR, payload: 'Failed to load machine list' });
      }
    } catch (error) {
      setMachineList([]);
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  const getTaskInfo = () => {
    const taskType = taskData.selectTask;

    const date = new Date(taskData.date_Time);
    const formattedDateTime = toLocalISO(date);

    if (taskType == 'Clock In') {
      //vehical check list
      //normal clock in data

      getVehicalCheckList();
      setClockInData({
        employeeName: taskData.employeeName,
        additionalInformation: taskData.additionalInformation,
        date_Time: formattedDateTime,
        machine: taskData.machine,
        doYouDriveACompanyVan: taskData.doYouDriveACompanyVan,
        forestSPNumber: taskData.forestSPNumber,
        haveCompletedVanDriverWalkAroundCheckSheet: taskData.haveCompletedVanDriverWalkAroundCheckSheet == '1',
        vanRegistration: taskData.vanRegistration,
      });
    } else if (taskType === 'Daily Harvesting Close') {
      //normal harvesting data
      //production data
      //harbestinf maintenance check list
      //files
      getProductionData();
      getForwardingHarvestingMaintenanceCheckList('harvesting');
      getDocs();
      setHarvestingClosingData({
        employeeName: taskData.employeeName,
        additionalInformation: taskData.additionalInformation,
        date_Time: formattedDateTime,
        forestSPNumber: taskData.forestSPNumber,
        fullNameAccommodation: taskData.fullNameAccommodation,
        machine: taskData.machine,
        movedLocationForSignal: taskData.movedLocationForSignal == '1',
        overnightStay: taskData.overnightStay,
        nonProductiveHours: taskData.nonProductiveHours,
        reasonForNonProductiveHours: taskData.reasonForNonProductiveHours,
        species: taskData.species,
        subsistenceTracking: taskData.subsistenceTracking == '1',
        total_M3: taskData.total_M3,
        total_M3PerHr: taskData.total_M3PerHr,
        wasTheirTopsLeftToOneSideForTheForwarder: taskData.wasTheirTopsLeftToOneSideForTheForwarder,
        wasTheirTopsLeftToOneSideForTheForwarderReason: taskData.wasTheirTopsLeftToOneSideForTheForwarderReason,
        managerApprovedDowntime: taskData.managerApprovedDowntime,
        siteBonus: taskData.siteBonus,
        machineBonus: taskData.machineBonus,
        managerFeedback: taskData.managerFeedback,
        unitOfMeasure: taskData.unitOfMeasure,
        totalValue: taskData.totalValue,

      });
    } else if (taskType == 'Daily Forwarding Close') {
      //normal forwarding data
      //production data
      //forwarding maintenance check list
      //files
      getForwardingHarvestingMaintenanceCheckList('forwarding');
      getProductionData();
      getDocs();
      setForwardingData({
        employeeName: taskData.employeeName,
        additionalInformation: taskData.additionalInformation,
        date_Time: formattedDateTime,
        forestSPNumber: taskData.forestSPNumber,
        fullNameAccommodation: taskData.fullNameAccommodation,
        machine: taskData.machine,
        movedLocationForSignal: taskData.movedLocationForSignal == '1',
        overnightStay: taskData.overnightStay,
        nonProductiveHours: taskData.nonProductiveHours,
        reasonForNonProductiveHours: taskData.reasonForNonProductiveHours,
        species: taskData.species,
        subsistenceTracking: taskData.subsistenceTracking == '1',
        total_M3: taskData.total_M3,
        total_M3PerHr: taskData.total_M3PerHr,
        wasTheirTopsLeftToOneSideForTheForwarder: taskData.wasTheirTopsLeftToOneSideForTheForwarder,
        wasTheirTopsLeftToOneSideForTheForwarderReason: taskData.wasTheirTopsLeftToOneSideForTheForwarderReason,
        managerApprovedDowntime: taskData.managerApprovedDowntime,
        siteBonus: taskData.siteBonus,
        machineBonus: taskData.machineBonus,
        managerFeedback: taskData.managerFeedback,
        unitOfMeasure: taskData.unitOfMeasure,
        totalValue: taskData.totalValue,
      });
    } else if (taskType === 'Daily Other Work Close') {
      //daily other work close data
      //forwarding and harvesting maintenance check list
      getForwardingHarvestingMaintenanceCheckList('both');
      setDailyOtherWorkCloseData({
        employeeName: taskData.employeeName,
        additionalInformation: taskData.additionalInformation,
        date_Time: formattedDateTime,
        fullNameAccommodation: taskData.fullNameAccommodation,
        machine: taskData.machine,
        overnightStay: taskData.overnightStay,
        subsistenceTracking: taskData.subsistenceTracking == '1',
        managerApprovedDowntime: taskData.managerApprovedDowntime,
        siteBonus: taskData.siteBonus,
        machineBonus: taskData.machineBonus,
        managerFeedback: taskData.managerFeedback,
        nonProductiveHours: taskData.nonProductiveHours,
        reasonForNonProductiveHours: taskData.reasonForNonProductiveHours,
      });
    } else if (taskType == 'Completed Forest') {
      //completed forest data
      //files
      //production data
      setCompletedForestData({
        employeeName: taskData.employeeName,
        date_Time: formattedDateTime,
        forestSPNumber: taskData.forestSPNumber,
        machine: taskData.machine,
        species: taskData.species,
        total_M3PerHr: taskData.total_M3PerHr,
      });
      getProductionData();
      getDocs();
    } else if (taskType == 'Stock Take') {
      //stock take data
      //production data
      setStockTakeData({
        employeeName: taskData.employeeName,
        date_Time: formattedDateTime,
        additionalInformation: taskData.additionalInformation,
        forestSPNumber: taskData.forestSPNumber,
        species: taskData.species,
      });
      getProductionData();
    } else if (taskType == 'Expense Claim') {
      //expense claim data
      //files
      setExpenseClaimData({
        employeeName: taskData.employeeName,
        additionalInformation: taskData.additionalInformation,
        expenseClaim: taskData.expenseClaim,
      });
      getDocs();
    } else if (taskType == 'Other') {
      //other task data
      //files
      console.log('TASK DATA ====', taskData);
      setOtherTaskData({
        employeeName: taskData.employeeName,
        additionalInformation: taskData.additionalInformation,
        date_Time: formattedDateTime,
        durationInHours: taskData.durationInHours,
        missingHours: taskData.missingHours || taskData.nonProductiveHours,
        nonProductiveHours: taskData.nonProductiveHours,
        reasonForNonProductiveHours: taskData.reasonForNonProductiveHours,
      });
      getDocs();
    } else if (taskType == 'Holidays') {
      //holidays daata
      setHolidayData({
        employeeName: taskData.employeeName,
        additionalInformation: taskData.additionalInformation,
        date_Time: formattedDateTime,
        totalNumberOfDays: taskData.totalNumberOfDays,
      });
    } else if (taskType === 'Help Videos') {
      //no data needed
    }
  };
  const getVehicalCheckList = () => {
    let url = '/Ops/GetTasksVehicleChecklist/' + taskData.id;
    customAxios.get(url, { headers: authHeader() }).then(response => {
      if (response.status === 200) {
        setVehicalChecklist(response.data.length > 0 ? response.data[0] : DEFAULT_VEHICAL_CHECK_LIST);
      }
    });
  };
  const getProductionData = () => {
    let url = '/OPS/GetTasksProductionRecord/' + taskData.id;
    customAxios
      .get(url, { headers: authHeader() })
      .then(response => {
        if (response.status === 200) {
          setProductionData(response.data);
          let prodObj = {};
          for (let i = 0; i < response.data.length; i++) {
            let item = response.data[i];
            prodObj[item.id] = item;
          }
          setOldProductionData(prodObj);
        }
      })
      .catch(error => {
        dispatch({ type: FETCH_ERROR, payload: 'Error Loading Production Data ' });
      });
  };
  const getForwardingHarvestingMaintenanceCheckList = typeOfCheckList => {
    let url = '/OPS/GetTasksMachineChecklist/' + taskData.id;
    customAxios
      .get(url, { headers: authHeader() })
      .then(response => {
        if (response.status === 200) {
          let data =
            response.data && response.data.length > 0
              ? response.data[0]
              : { ...DEFAULT_HARVESTING_MAINTENANCE_CHECK_LIST, id: null, taskId: taskData.id };
          if (typeOfCheckList == 'harvesting') {
            setHarvestingMaintenanceCheckList(data);
          } else if (typeOfCheckList == 'forwarding') {
            setForwardingMaintenanceCheckListData(data);
          } else {
            setHarvestingMaintenanceCheckList(data);
            setForwardingMaintenanceCheckListData(data);
          }
        }
      })
      .catch(error => {
        dispatch({ type: FETCH_ERROR, payload: 'Error Loading Checklist Data ' });
      });
  };
  const getDocs = () => {
    let url = '/Ops/GetTasksDocs/' + taskData.id;
    customAxios
      .get(url, { headers: authHeader() })
      .then(res => {
        if (res.status === 200) {
          setFiles(res.data);
        }
      })
      .catch(error => {
        dispatch({ type: FETCH_ERROR, payload: 'Error Loading Documenets  ' });
      });
  };

  function getProductionDataAfterEdit() {
    return new Promise((resolve, reject) => {
      let newProductionData = [];
      let toDeleteProductionData = [];
      let toEditProducitonData = [];
      let nonDeltedData = [];
      for (let i = 0; i < productionData.length; i++) {
        let item = productionData[i];
        let isItemNew = item.id == null || item.id == undefined || oldProoductionData[item.id] == undefined;
        if (isItemNew) {
          newProductionData.push(item);
        } else {
          toEditProducitonData.push(item);
          nonDeltedData.push(item.id);
        }
      }
      //get the list deltedItem
      // Object.keys(oldProoductionData).forEach(key => {
      //   if (!nonDeltedData.includes(key)) {
      //     toDeleteProductionData.push(oldProoductionData[key]);
      //   }
      // });
      resolve({ newProductionData, toDeleteProductionData, toEditProducitonData });
    });
  }
  const submitEditedData = async () => {
    const taskType = currentTaskType;
    let newTaskData = { ...taskData, selectTask: currentTaskType };
    let isMaintanenceCheckListEdit = false;
    let maintenanceCheckListName = '';
    let isProductionDataEdit = false;
    let isVehicalCheckListEdit = false;
    let isfilesEdit = false;

    if (taskType == 'Clock In') {
      //vehical check list
      //normal clock in data

      newTaskData = {
        ...newTaskData,
        ...clockInData,
        haveCompletedVanDriverWalkAroundCheckSheet: clockInData.haveCompletedVanDriverWalkAroundCheckSheet ? '1' : '0',
      };
      isVehicalCheckListEdit = true;
      console.log('Clock In Data', newTaskData, vehicalCheckList);
    } else if (taskType === 'Daily Harvesting Close') {
      //normal harvesting data
      //production data
      //harbestinf maintenance check list
      //files
      newTaskData = {
        ...newTaskData,
        ...harvestingClosingData,
        subsistenceTracking: harvestingClosingData.subsistenceTracking ? '1' : '0',
        movedLocationForSignal: harvestingClosingData.movedLocationForSignal ? '1' : '0',
      };
      isMaintanenceCheckListEdit = true;
      maintenanceCheckListName = 'harvesting';
      isProductionDataEdit = true;
      isfilesEdit = true;
    } else if (taskType == 'Daily Forwarding Close') {
      //normal forwarding data
      //production data
      //forwarding maintenance check list
      //files
      newTaskData = {
        ...newTaskData,
        ...forwardingData,
        subsistenceTracking: forwardingData.subsistenceTracking ? '1' : '0',
        movedLocationForSignal: forwardingData.movedLocationForSignal ? '1' : '0',
      };
      isMaintanenceCheckListEdit = true;
      maintenanceCheckListName = 'forwarding';
      isProductionDataEdit = true;
      isfilesEdit = true;
    } else if (taskType === 'Daily Other Work Close') {
      //daily other work close data
      //forwarding and harvesting maintenance check list

      newTaskData = {
        ...newTaskData,
        ...dailyOtherWorkCloseData,
        subsistenceTracking: dailyOtherWorkCloseData.subsistenceTracking ? '1' : '0',
      };
      isMaintanenceCheckListEdit = true;
      maintenanceCheckListName = 'both';
    } else if (taskType == 'Completed Forest') {
      //completed forest data
      //files

      newTaskData = {
        ...newTaskData,
        ...completedForestData,
      };
      isfilesEdit = true;
    } else if (taskType == 'Stock Take') {
      //stock take data
      //production data

      newTaskData = {
        ...newTaskData,
        ...stockTakeData,
      };
      isProductionDataEdit = true;
    } else if (taskType == 'Expense Claim') {
      //expense claim data
      //files
      newTaskData = {
        ...newTaskData,
        ...expenseClaimData,
      };
      isfilesEdit = true;
    } else if (taskType == 'Other') {
      //other task data
      //files

      newTaskData = {
        ...newTaskData,
        ...otherTaskData,
      };
      isfilesEdit = true;
    } else if (taskType == 'Holidays') {
      //holidays daata
      newTaskData = {
        ...newTaskData,
        ...holidayData,
      };
    } else if (taskType === 'Help Videos') {
      //no data needed
      return;
    }

    let isTaskEdited = await handleEditTask(newTaskData);
    if (!isTaskEdited) return;
    if (isMaintanenceCheckListEdit) {
      let isMaintanceCheckListEdited = await handleMaintanceCheckListEdit(maintenanceCheckListName, newTaskData);
      if (!isMaintanceCheckListEdited) return;
    }
    if (isVehicalCheckListEdit) {
      let isVehicalCheckListEdited = await updateVehicalCheckList(newTaskData);
      if (!isVehicalCheckListEdited) return;
    }
    if (isProductionDataEdit) {
      let isProductionDataEdited = await handleProductionDataEdit();
      if (!isProductionDataEdited) return;
    }
    if (isfilesEdit) {
      let isNewFileUploaded = await uploadNewDocs('files')(newTaskData);
    }
    handleSuccessfulSubmit();

    handleClose();
  };

  const handleProductionDataEdit = async () => {
    return new Promise(async (resolve, reject) => {
      const { newProductionData, toDeleteProductionData, toEditProducitonData } = await getProductionDataAfterEdit();
      if (toEditProducitonData.length > 0) await editProductionData(toEditProducitonData);
      if (newProductionData.length > 0) await addNewproductionData(newProductionData);
      resolve(true);
    });
  };
  const deleteProductionData = async toDeleteProdData => {
    // await new Promise(res=>{
    //   dispatch({ type: FETCH_START });
    // })
  };
  const editProductionData = async toEditProducitonData => {
    let url = '/Ops/EditTasksProductionRecord';

    return new Promise(res => {
      dispatch({ type: FETCH_START });

      customAxios
        .post(url, toEditProducitonData, { headers: authHeader() })
        .then(response => {
          dispatch({ type: FETCH_SUCCESS });
          if (response.status === 200) {
            res(true);
          } else {
            res(false);
          }
        })
        .catch(error => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Editing Production Records ' });
        });
    });
  };
  const addNewproductionData = async newProductionData => {
    let url = '/Ops/AddTasksProductionRecord';
    for (let i = 0; i < newProductionData.length; i++) {
      newProductionData[i]['taskId'] = taskData.id;
    }
    return new Promise(res => {
      dispatch({ type: FETCH_START });

      customAxios
        .post(url, newProductionData, { headers: authHeader() })
        .then(response => {
          dispatch({ type: FETCH_SUCCESS });
          if (response.status === 200) {
            res(true);
          } else {
            res(false);
          }
        })
        .catch(error => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Adding New Production Records ' });
        });
    });
  };
  const handleEditTask = async newTaskData => {
    return new Promise(res => {
      let url = '/Ops/EditTasks';
      dispatch({ type: FETCH_START });
      newTaskData['dateTime'] = newTaskData.date_Time;
      newTaskData['whDocketNo'] = newTaskData.wH_DocketNo;
      //     "total_M3": 0,
      // "total_M3PerHr": 0,

      customAxios
        .post(url, newTaskData, { headers: authHeader() })
        .then(response => {
          dispatch({ type: FETCH_SUCCESS });
          if (response.status === 200) {
            res(true);
          } else {
            res(false);
          }
        })
        .catch(error => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Editing Task Data ' });
        });
    });
  };
  const handleMaintanceCheckListEdit = (typeOfCheckList, newTaskData) => {
    console.log(
      'typeOfCheckList',
      typeOfCheckList,
      'harvestingMaintenanceCheckList',
      harvestingMaintenanceCheckList,
      'forwardingMaintenanceCheckListData',
      forwardingMaintenanceCheckListData,
    );
    let maintenanceCheckListData = {};
    if (typeOfCheckList === 'harvesting') {
      maintenanceCheckListData = { ...harvestingMaintenanceCheckList };
    } else if (typeOfCheckList === 'forwarding') {
      maintenanceCheckListData = { ...forwardingMaintenanceCheckListData };
    } else {
      maintenanceCheckListData = {
        ...harvestingMaintenanceCheckList,
        ...forwardingMaintenanceCheckListData,
      };
    }

    // key change: branch by whether a real id exists
    const isNew = maintenanceCheckListData.id == null;
    const url = isNew ? '/Ops/AddTasksMachineChecklist' : '/Ops/EditTasksMachineChecklist';
    const payload = isNew
      ? { taskId: newTaskData.id, ...maintenanceCheckListData }
      : { id: maintenanceCheckListData.id, taskId: maintenanceCheckListData.taskId, ...maintenanceCheckListData };

    dispatch({ type: FETCH_START });
    return new Promise(res => {
      customAxios
        .post(url, payload, { headers: authHeader() })
        .then(response => {
          dispatch({ type: FETCH_SUCCESS });
          res(response.status === 200);
        })
        .catch(() => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Editing Task Data' });
        });
    });
  };
  const updateVehicalCheckList = async newTaskData => {
    const isNew = !vehicalCheckList.id;
    const url = isNew ? '/Ops/AddTasksVehicleChecklist' : '/Ops/EditTasksVehicleChecklist';
    const payload = isNew
      ? { taskId: newTaskData.id, ...vehicalCheckList }
      : { id: vehicalCheckList.id, taskId: vehicalCheckList.taskId, ...vehicalCheckList };

    return new Promise(res => {
      dispatch({ type: FETCH_START });
      customAxios
        .post(url, payload, { headers: authHeader() })
        .then(response => {
          dispatch({ type: FETCH_SUCCESS });
          res(response.status === 200);
        })
        .catch(() => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Editing Task Data' });
        });
    });
  };
  const uploadNewDocs = key => async taskData => {
    console.log('NEW FIles ====', newUploadedFiles);
    return new Promise(res => {
      let url = '/Ops/AddTasksDocs';
      //taskId ,docType, file
      let formData = new FormData();
      if (!newUploadedFiles || newUploadedFiles.length == 0) {
        res(true);
        return;
      }

      dispatch({ type: FETCH_START });
      formData.append('taskId', taskData.id);
      formData.append('docType', taskData.selectTask);
      for (let i = 0; i < newUploadedFiles.length; i++) {
        let file = newUploadedFiles[i];
        console.log('FILE ====', file);
        formData.append(`file[${i}]`, file);
      }

      customFormAxios
        .post(url, formData, { headers: authHeader() })
        .then(response => {
          if (response.status === 200) {
            dispatch({ type: FETCH_SUCCESS });
            res(true);
          } else {
            res(false);
          }
        })
        .catch(error => {
          res(false);
          dispatch({ type: FETCH_ERROR, payload: 'Error Uploading document ' });
        });
    });
  };

  const handleDeleteFile = fileDataToDelete => {
    console.log(fileDataToDelete);

    if (window.confirm('Are you sure you want to delete this Document?')) {
      dispatch({ type: FETCH_START });

      let url = '/Ops/DeleteTasksDocs';
      customAxios
        .post(url, { id: fileDataToDelete.id }, { headers: authHeader() })
        .then(data => {
          if (data.status == 200) {
            showToast('File deleted successfully.', 'success');
            getDocs();
          }
          dispatch({ type: FETCH_SUCCESS });
        })
        .catch(error => {
          console.log(error);
          dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
        });
    }
  };

  const viewFile = async fileData => {
    try {
      dispatch({ type: FETCH_START });

      const response = await customAxios.get(`/Ops/GetTasksFile/${fileData.id}`, {
        headers: authHeader(),
        responseType: 'blob',
      });

      const url = URL.createObjectURL(response.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = fileData.documentName;
      document.body.appendChild(a);
      a.click();
      window.URL.revokeObjectURL(url);

      dispatch({ type: FETCH_SUCCESS });
    } catch (err) {
      console.log(err);
      dispatch({ type: FETCH_ERROR, payload: 'Network Error' });
    }
  };

  return {
    expenseClaimData,
    setExpenseClaimData,
    otherTaskData,
    setOtherTaskData,
    holidayData,
    setHolidayData,
    handleClose,
    spList,
    spListObj,
    clockInData,
    vehicalCheckList,
    setClockInData,
    setVehicalChecklist,
    harvestingMaintenanceCheckList,
    harvestingClosingData,
    setHarvestingMaintenanceCheckList,
    setHarvestingClosingData,
    productionData,
    setProductionData,
    forwardingData,
    setForwardingData,
    forwardingMaintenanceCheckListData,
    setForwardingMaintenanceCheckListData,
    dailyOtherWorkCloseData,
    setDailyOtherWorkCloseData,
    files,
    setFiles,
    completedForestData,
    setCompletedForestData,
    newUploadedFiles,
    setNewUploadedFiles,
    stockTakeData,
    setStockTakeData,
    submitEditedData,
    handleDeleteFile,
    viewFile,
    machineList,
  };
};

export default useHFOpsFormEditHook;
